// NewCampaign.js - Studio wrapper for PublicGameCreator
import React from 'react';
import { useUser } from '../userContext';
import PublicGameCreator from '../games/PublicGameCreator';

function NewCampaign() {
  const { user, businessProfile } = useUser();

  // Studio-specific configuration
  const studioConfig = {
    isStudioMode: true,
    showPrivacyToggle: false, // Studio campaigns are always private by default
    defaultPrivate: true,
    headerText: {
      title: "NEW CAMPAIGN",
      subtitle: "Create your next epic gaming experience"
    },
    stepTitles: {
      step1: "Choose your game type",
      step2: "Set up your game", 
      step3: "Review your game",
      step4: "Campaign created!"
    },
    buttonText: {
      create: "🚀 CREATE CAMPAIGN",
      success: "🎉 Campaign Created!"
    },
    redirectPath: "/studio/campaign", // Where to redirect after creation
    collectionName: "campaign", // Firestore collection
    additionalData: {
      createdBy: user?.uid,
      companyId: businessProfile?.id, // Essential for campaign association
      businessProfile: businessProfile,
        status: 'draft',
      arcade: false // Studio campaigns are not arcade games
    }
  };

  return (
    <PublicGameCreator 
      config={studioConfig}
      user={user}
                    businessProfile={businessProfile}
    />
  );
}

export default NewCampaign;
